import { render } from "./ChatBot.vue?vue&type=template&id=29a31bad&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"

import "./ChatBot.vue?vue&type=style&index=0&id=29a31bad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a31bad"]])

export default __exports__